import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Quotedata } from "../../data";
import { Col, Container, Row } from "react-bootstrap";
import Loading from "../../components/Loading ";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";

const QuoteDetails = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);

  const product = Quotedata.filter((e) => e.page === slug);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="spinner-container">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <SectionHeader
        title={slug}
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Detail About Vendor"
        content=""
      />

      <Container className="vista-view">
        {/* <Row>
          <Col md={12}> */}
            <div className="vista">
              <Row>
                {product.length > 0 ? (
                  product.map((prod) => (
                    <Col sm={6} md={4} lg={3}  key={prod.id} className="g-3">
                      <div className="vista-card">
                        <div className="vista-title">
                          <div className="vista-img">
                            <h2>{prod.name}</h2>
                            <p>{prod.page}</p>
                            <img src={prod.image} alt={prod.name} />
                          </div>
                          <Link to={`/${prod.name}/ConfigForm`}>Select</Link>
                        </div>
                      </div>
                    </Col>
                  ))
                ) : (
                  <Col md={12}>
                    <p>Product not found</p>
                  </Col>
                )}
              </Row>
            </div>
          {/* </Col>
        </Row> */}
      </Container>
    </>
  );
};

export default QuoteDetails;
